import { render, staticRenderFns } from "./TestReview.vue?vue&type=template&id=d7aa98da&"
import script from "./TestReview.vue?vue&type=script&lang=js&"
export * from "./TestReview.vue?vue&type=script&lang=js&"
import style0 from "./TestReview.vue?vue&type=style&index=0&id=d7aa98da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports